import { defineComponent as _defineComponent } from 'vue'
import DeletedPageDetailsModal from "@/components/modules/bet-details/DeletedPageDetailsModal.vue";
import UserBreadcrumb from "@/components/common/UserBreadcrumb.vue";
import { queries } from "@/apollo";
import { DeletedDdPage, User } from "@/CodegenTypes";

import { sumBy, startCase, first } from "lodash";
import { formatDollar } from "@/helpers/formatDollar";
import { formatCount } from "@/helpers/formatCount";
import AccountSelectModal from "@/components/modules/account/AccountSelectModal.vue";
import AccountSelectSearch from "@/components/modules/account/AccountSelectSearch.vue";
import { customMoment } from "@/main";
import { useTranslation } from "@/store/translation";
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute } from "vue-router/composables";

type RouteQueryValue = string | (string | null)[] | null | undefined;


export default /*#__PURE__*/_defineComponent({
  __name: 'DeletedBetDetails',
  setup(__props) {

const route = useRoute();
const { $t } = useTranslation();
const t = (text: string) => $t(text);

const showAccountSelectionModal = ref(false);
const selectedPage = ref<null | DeletedDdPage>(null);
const showPageDetailModal = ref(false);

const selectedStartReleaseDate = computed(() =>
  getRouteQueryValue(route.query.startReleaseDate)
);
const selectedUserId = computed(() => getRouteQueryValue(route.query.userId));
const userDeletedPagesVariables = computed(() => {
  return {
    releaseDate: customMoment(selectedStartReleaseDate.value)
      .startOf("day")
      .toDate(),
    behalfOf: selectedUserId.value,
  };
});

const { result: userDeletedPagesResult, loading: apolloLoading } = useQuery<{
  user: User;
}>(queries.userDeletedPages, userDeletedPagesVariables, {
  enabled: computed(() => !!selectedStartReleaseDate.value),
  fetchPolicy: "cache-and-network",
});

const user = computed(() => userDeletedPagesResult.value?.user ?? null);
const pageDetailsData = computed(() => {
  const currUser = user.value;
  if (!currUser) {
    return [];
  }

  const downlinesData = currUser.deletedPages
    .map((page) => {
      const big = page.calculation.bigCount;
      const small = page.calculation.smallCount;
      const amount = page.calculation.rawCost;
      return {
        ...page,
        upline: page.userId,
        uplineName: page.username,
        account: page.userId,
        username: page.username,
        big,
        small,
        amount,
        accountCount: currUser.deletedPages.filter(
          (u) => u.userId === page.userId
        ).length,
        createdAt: page.createdAt,
      };
    })
    .filter((u) => u.amount > 0)
    .sort(
      (u1, u2) =>
        customMoment(u1.createdAt).unix() - customMoment(u2.createdAt).unix()
    )
    .sort((u1, u2) => u1.upline.localeCompare(u2.upline));

  return downlinesData.map((row) => {
    return {
      ...row,
      uplineCount: downlinesData.filter((d) => d.upline === row.upline).length,
      accountCount: downlinesData.filter((d) => d.account === row.account)
        .length,
    };
  });
});
const pageDetailTotal = computed(() => {
  const data = pageDetailsData.value;
  return {
    big: sumBy(data, (d) => d.big).toFixed(2),
    small: sumBy(data, (d) => d.small).toFixed(2),
    amount: formatDollar(sumBy(data, (d) => d.amount)),
  };
});

function getRouteQueryValue(query: RouteQueryValue) {
  return Array.isArray(query) ? first(query) : query;
}

function rowTestId(value: string) {
  return String(value || "unknown")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");
}

function formatDate(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY hh:mm:ss A");
}

function viewPageDetails(id: DeletedDdPage["id"]) {
  const page = pageDetailsData.value.find((p) => p.id === id);
  if (!page) {
    return;
  }
  selectedPage.value = page;
  showPageDetailModal.value = true;
}

return { __sfc: true,route, $t, t, showAccountSelectionModal, selectedPage, showPageDetailModal, selectedStartReleaseDate, selectedUserId, userDeletedPagesVariables, userDeletedPagesResult, apolloLoading, user, pageDetailsData, pageDetailTotal, getRouteQueryValue, rowTestId, formatDate, viewPageDetails, DeletedPageDetailsModal, UserBreadcrumb, startCase, formatCount, AccountSelectModal, AccountSelectSearch }
}

})